'use client';

import { useEffect } from 'react';
import isPrintModalEnabled, { PRINT_MODAL_EXPERIMENT_KEY } from '../utils/isPrintModalEnabled';
import preloadExperimentClient from '../utils/preloadExperimentClient';
import useExperiments from './useExperiments';
import useExposureEvent from './useExposureEvent';

/** For surfaces that report a print entry. Read-only callers want useIsPrintModalEnabled instead. */
const usePrintModalExperiment = () => {
  const experiments = useExperiments();
  const sendExposure = useExposureEvent(PRINT_MODAL_EXPERIMENT_KEY);

  useEffect(() => {
    if (typeof window.requestIdleCallback !== 'function') {
      preloadExperimentClient();
      return undefined;
    }
    const handle = window.requestIdleCallback(() => preloadExperimentClient());
    return () => window.cancelIdleCallback(handle);
  }, []);

  return { isEnabled: isPrintModalEnabled(experiments), sendExposure };
};

export default usePrintModalExperiment;
